import { useRef, useEffect } from "react";
import { useState } from "react";
import { Box, Typography } from "@mui/material";
import EmailIcon from "@mui/icons-material/Email";
import LocalPhoneIcon from "@mui/icons-material/LocalPhone";
import LocationOnIcon from "@mui/icons-material/LocationOn";

import { SEO } from "../../components";
import THEME from "../../constants/theme";
import CustomAccordion from "../../components/common/CustomAccordion";
import OfficeMap from "../../components/pages/contacts/OfficeMap";

const ContactsPage = ({ setRefs }) => {
  const contactsRef = useRef(null);
  const officeLocations = [
    {
      id: "london",
      icon: (
        <LocationOnIcon
          sx={{ fontSize: "2rem", color: THEME.COLORS.PRIMARY_PURPLE }}
        />
      ),
      title: "London Office",
      content: "167-169 Great Portland Street 5th Floor\nW1W 5PF\nLondon, UK",
    },
    {
      id: "lisbon",
      icon: (
        <LocationOnIcon
          sx={{ fontSize: "2rem", color: THEME.COLORS.PRIMARY_PURPLE }}
        />
      ),
      title: "Lisbon Office",
      content: "Estrada da Malveira da Serra, 920\n2750-834\nCascais, Portugal",
    },
  ];

  const [selectedOfficeId, setSelectedOfficeId] = useState(null);

  useEffect(() => {
    setRefs({ contacts: contactsRef });
  }, [setRefs]);

  // To use Google Maps, add this to your .env file:
  // REACT_APP_GOOGLE_MAPS_SECRET_KEY=your_api_key_here

  return (
    <>
      <SEO
        title="Contacts"
        description="Connect with Spinnaker Algo Systems LTD for inquiries about our algorithmic trading solutions."
        keywords="contact, algorithmic trading, OctopusSync, Sentinel, Spinnaker Algo Systems, London, Lisbon"
      />
      <Box
        ref={contactsRef}
        id="contacts"
        sx={{
          minHeight: "100vh",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "flex-start",
          backgroundColor: "#fff",
          position: "relative",
          overflow: "hidden",
          padding: { xs: "80px 10px 30px 10px", md: "100px 30px 40px 30px" },
          gap: 4,
          width: "100%",
          maxWidth: 1400,
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", md: "row" },
            width: "100%",
            gap: 4,
            mb: 2,
          }}
        >
          <Box sx={{ flex: { xs: "unset", md: 3 }, width: { xs: "100%", md: "60%" } }}>
            <Typography
              variant="h3"
              sx={{ mb: 3, fontWeight: 700, color: THEME.COLORS.PRIMARY_PURPLE }}
            >
              Our Offices
            </Typography>
            <CustomAccordion
              items={officeLocations}
              onChange={(idx, item) =>
                setSelectedOfficeId(selectedOfficeId === item.id ? null : item.id)
              }
            />
          </Box>
          <Box sx={{ flex: { xs: "unset", md: 2 }, width: { xs: "100%", md: "40%" } }}>
            <Typography
              variant="h4"
              sx={{
                mb: 2,
                fontWeight: 700,
                color: THEME.COLORS.PRIMARY_PURPLE,
              }}
            >
              Contact
            </Typography>
            <Box sx={{ mt: { xs: 0, md: 9 } }}>
              <Typography
                variant="body1"
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 1,
                  color: THEME.COLORS.NEUTRAL_BLACK,
                }}
              >
                <EmailIcon
                  sx={{
                    fontSize: "1.5rem",
                    color: THEME.COLORS.PRIMARY_PURPLE,
                    mr: 1,
                  }}
                />
                Email: inquiries@spinnakeralgo.com
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 1,
                  color: THEME.COLORS.NEUTRAL_BLACK,
                  mt: 1,
                }}
              >
                <LocalPhoneIcon
                  sx={{
                    fontSize: "1.5rem",
                    color: THEME.COLORS.PRIMARY_PURPLE,
                    mr: 1,
                  }}
                />
                Phone: +44 20 4587 9699
              </Typography>
            </Box>
          </Box>
        </Box>
        <Box
          sx={{
            width: "100%",
            height: { xs: "40vh", md: "55vh", lg: "60vh" },
            borderRadius: 3,
            boxShadow: 4,
            overflow: "hidden",
            mt: 2,
            maxWidth: 1400,
            alignSelf: "center",
          }}
        >
          <OfficeMap selectedOfficeId={selectedOfficeId} />
        </Box>
      </Box>
    </>
  );
};

export default ContactsPage;
